import { render, staticRenderFns } from "./MemberMessagePopup.vue?vue&type=template&id=1e4e5f0a&scoped=true&"
import script from "./MemberMessagePopup.vue?vue&type=script&lang=js&"
export * from "./MemberMessagePopup.vue?vue&type=script&lang=js&"
import style0 from "./MemberMessagePopup.vue?vue&type=style&index=0&id=1e4e5f0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4e5f0a",
  null
  
)

export default component.exports